import { BrowserRouter, Route, Routes } from "react-router-dom";
import CrearPregunta from "./pages/CreaPreguntas";
import Unificado from "./pages/Unificado";
import SidebarMenu from "./components/sidebar/Sidebar";
import "../src/components/css/fomr.css";
import SubeImagen from "./pages/SubeImahen";
import Resultados from "./pages/Obtener/Resultados";
import GraciasComponente from "./pages/Obtener/Finalizar";
import FormularioPrincipal from "./pages/FormularioPrincipal ";
import Publicado from "./pages/Publicado";
import Duplica from "./pages/Duplicar";
import DuplicaVariables from "./pages/Obtener/DuplicarCamposVariables";

function App() {
  const currentPath = window.location.pathname;

  // Rutas donde NO se debe mostrar el Sidebar
  const showSidebar = !(
    currentPath.startsWith("/Formulario") ||
    currentPath === "/Finaliza" ||
    currentPath.startsWith("/Publicado")
  );

  return (
    <div className="App">
      {/* Renderizar Sidebar basado en la ruta actual */}
      {showSidebar && <SidebarMenu />}
      <BrowserRouter>
        <Routes>
          <Route path="/Preguntas/:id" element={<CrearPregunta />} />
          <Route path="/" element={<FormularioPrincipal />} />
          <Route path="/Formulario/:id" element={<Unificado />} />
          <Route path="/SubeImagen/:id" element={<SubeImagen />} />
          <Route path="/Resultados/:id" element={<Resultados />} />
          <Route path="/Publicado/:id" element={<Publicado />} />
          <Route path="/Finaliza" element={<GraciasComponente />} />
          <Route path="/Duplica/:id" element={<Duplica />} />
          <Route
            path="/DuplicaVariables/:idNuevo/:idAntiguo"
            element={<DuplicaVariables />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
